<div class="form-group">
  <label for="member">Member</label>

  <select class="custom-select"
          id="member" name="member"
          [(ngModel)]="member">
    <option *ngFor="let member of getActionableMembers()"
            [ngValue]="member">
      {{ member.first_name }} {{ member.last_name }}
    </option>
  </select>
</div>

<div class="form-group">
  <label>Unfreeze Date</label>

  <div class="form-check">
    <input class="form-check-input" type="radio"
           name="unfreezeDate" id="unfreezeDateImmediately"
           [(ngModel)]="unfreezeDate" (ngModelChange)="updateUnfreezeDaysFromNow()"
           [value]="UNFREEZE_DATE_IMMEDIATELY">
    <label class="form-check-label" for="unfreezeDateImmediately">
      Immediately
    </label>
  </div>
  <div class="form-check" *ngFor="let upcomingBillDate of membership.upcoming_bill_dates">
    <input class="form-check-input" type="radio"
           name="unfreezeDate" id="unfreezeDate{{ upcomingBillDate }}"
           [(ngModel)]="unfreezeDate" (ngModelChange)="updateUnfreezeDaysFromNow()"
           [value]="upcomingBillDate">
    <label class="form-check-label" for="unfreezeDate{{ upcomingBillDate }}">
      {{ dateStringFromISO8601(upcomingBillDate) }}
    </label>
  </div>
</div>

<div class="alert alert-warning" *ngIf="unfreezeDaysFromNow && (unfreezeDaysFromNow > 30)">
  Your chosen unfreeze date is {{ unfreezeDaysFromNow }} days in the future. Please double check that this is correct before submitting.
</div>
<div class="alert alert-warning" *ngIf="unfreezeDate === UNFREEZE_DATE_IMMEDIATELY">
  The customer will be unfrozen immediately, with no charge. The next membership bill will reflect the customer's active state.
</div>
<div class="alert alert-danger" *ngIf="unfreezeDaysFromNow && (unfreezeDaysFromNow < 0)">
  The unfreeze date must be in the future.
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
